import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCreditCard, FiLock } from "react-icons/fi";
import "../css/footer.scss";
import siteConfig from "../siteConfig";
import BrandMark from "./BrandMark";
import { policyDocuments } from "../policies";

function Footer() {
  const location = useLocation();
  if (["/checkout", "/payment", "/paysuccess"].includes(location.pathname))
    return null;

  const firstPolicyColumn = policyDocuments.slice(0, 11);
  const secondPolicyColumn = policyDocuments.slice(11);

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="footer-service-strip" aria-label="Store information">
        <div>
          <span>Operating region</span>
          <strong>{siteConfig.operatingRegion}</strong>
        </div>
        <div>
          <span>Store currency</span>
          <strong>{siteConfig.currency}</strong>
        </div>
        <div>
          <span>Customer care</span>
          <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
        </div>
      </section>
      <div className="footer-grid">
        <div className="footer-brand">
          <Link className="footer-logo" to="/">
            <BrandMark />
          </Link>
          <p>{siteConfig.description}</p>
          <div className="payment-marks" aria-label="Supported checkout method">
            <span>
              <FiCreditCard /> Card
            </span>
            <span>
              <FiLock /> Hosted secure checkout
            </span>
          </div>
        </div>
        <div>
          <h3>Shop</h3>
          <Link to="/shop">All products</Link>
          <Link to="/shop?category=Decorative%20Homeware">
            Decorative homeware
          </Link>
          <Link to="/shop?category=Kitchen%20%2B%20Dining">
            Kitchen + dining
          </Link>
          <Link to="/shop?category=Lifestyle">Lifestyle</Link>
          <Link to="/about">Our story</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div>
          <h3>Policies A–L</h3>
          {firstPolicyColumn.map((policy) => (
            <Link key={policy.path} to={policy.path}>
              {policy.shortTitle}
            </Link>
          ))}
        </div>
        <div>
          <h3>Policies M–Z</h3>
          {secondPolicyColumn.map((policy) => (
            <Link key={policy.path} to={policy.path}>
              {policy.shortTitle}
            </Link>
          ))}
        </div>
        <div>
          <h3>Hong Kong fulfilment</h3>
          {siteConfig.contact.location.map((line) => (
            <span key={line}>{line}</span>
          ))}
          <span>{siteConfig.fulfilment.dispatchTime}</span>
          <small>{siteConfig.contact.locationStatus}</small>
        </div>
      </div>
      <div className="footer-bottom">
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
        <span>
          {siteConfig.operatingRegion} · {siteConfig.timezone} ·{" "}
          {siteConfig.currency}
        </span>
      </div>
    </footer>
  );
}

export default Footer;
